// Subscription tiers and access configuration
export const SUBSCRIPTION_TIERS = {
  FREE: 'free',
  SPORTS: 'sports', 
  HORSE_RACING: 'horse_racing',
  FULL_ACCESS: 'full_access'
}

// Pages/features available for each tier
export const TIER_ACCESS = {
  [SUBSCRIPTION_TIERS.FREE]: [
    'calculators',
    'tracker'
  ],
  [SUBSCRIPTION_TIERS.SPORTS]: [
    'calculators',
    'ev',
    'arb',
    'middles',
    'pickem',
    'prop_ev',
    'odds',
    'tracker',
    'education'
  ],
  [SUBSCRIPTION_TIERS.HORSE_RACING]: [
    'calculators',
    'bonus',
    'odds',
    'tracker',
    'education',
    'horse_bot',
    'racing_odds'
  ],
  [SUBSCRIPTION_TIERS.FULL_ACCESS]: [
    'calculators',
    'ev',
    'arb',
    'middles',
    'pickem',
    'prop_ev',
    'bonus',
    'odds',
    'tracker',
    'education',
    'horse_bot',
    'racing_odds'
  ]
}

// Pricing configuration
export const SUBSCRIPTION_PRICES = {
  weekly: {
    [SUBSCRIPTION_TIERS.SPORTS]: { price: 19.99, display: '$19.99/week' },
    [SUBSCRIPTION_TIERS.HORSE_RACING]: { price: 19.99, display: '$19.99/week' },
    [SUBSCRIPTION_TIERS.FULL_ACCESS]: { price: 34.99, display: '$34.99/week' }
  },
  monthly: {
    [SUBSCRIPTION_TIERS.SPORTS]: { price: 64.99, display: '$64.99/month' },
    [SUBSCRIPTION_TIERS.HORSE_RACING]: { price: 64.99, display: '$64.99/month' },
    [SUBSCRIPTION_TIERS.FULL_ACCESS]: { price: 109.99, display: '$109.99/month' }
  }
}

// Tier display names
export const TIER_NAMES = {
  [SUBSCRIPTION_TIERS.FREE]: 'Free',
  [SUBSCRIPTION_TIERS.SPORTS]: 'Sports Premium',
  [SUBSCRIPTION_TIERS.HORSE_RACING]: 'Promo Premium', 
  [SUBSCRIPTION_TIERS.FULL_ACCESS]: 'Full Access Premium'
}

// Check if user has access to a specific feature/page
export const hasAccess = (userTier, feature) => {
  if (!userTier) userTier = SUBSCRIPTION_TIERS.FREE
  return TIER_ACCESS[userTier]?.includes(feature) || false
}

// Get required tier for a feature
export const getRequiredTier = (feature) => {
  for (const [tier, features] of Object.entries(TIER_ACCESS)) {
    if (features.includes(feature)) {
      return tier
    }
  }
  return SUBSCRIPTION_TIERS.FULL_ACCESS // Default to highest tier if not found
}

// Get upgrade suggestions for a feature
export const getUpgradeOptions = (feature) => {
  const options = []
  
  for (const [tier, features] of Object.entries(TIER_ACCESS)) {
    if (features.includes(feature) && tier !== SUBSCRIPTION_TIERS.FREE) {
      options.push({
        tier,
        name: TIER_NAMES[tier],
        weeklyPrice: SUBSCRIPTION_PRICES.weekly[tier]?.display,
        monthlyPrice: SUBSCRIPTION_PRICES.monthly[tier]?.display
      })
    }
  }
  
  return options
}